// @flow
import * as React from 'react';
import { StyleSheet, View, TouchableWithoutFeedback } from 'react-native';
import PhoneLine from './PhoneLine';
import theme from '../../theme-config';

const PhonePicker = (props: Props) => {
  const styles = getStyles();
  if (!props.hasVisibleSubscriptions) return null;
  return (
    <View style={styles.container}>
      <TouchableWithoutFeedback onPress={props.onPress}>
        <View>
          <PhoneLine alias={props.alias} number={props.number} />
        </View>
      </TouchableWithoutFeedback>
    </View>
  );
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      paddingBottom: 10,
      backgroundColor: theme.headerBackgroundColor,
    },
  });

type Props = {
  alias: string,
  number: string,
  onPress: Function,
  onSelect: Function,
  hasVisibleSubscriptions: boolean,
};

export default PhonePicker;
